import { BTPopover } from "@btnet/core-components/BTPopover";

import { BdsIconJobs } from "@buildertrend/components";

import { BTIconTakeoffs } from "commonComponents/btWrappers/BTIcon";
import { getAccountingLabelText } from "commonComponents/financial/Common/accountingUtils";
import { JobPickerDisplayModes } from "commonComponents/utilities/JobPicker/JobPicker.types";
import {
    GLOBAL_DOCS,
    GLOBAL_JOB,
    type IJobIconProps,
} from "commonComponents/utilities/JobPicker/Sections/JobsList/JobsList.types";
import { StatusTagDisplay } from "commonComponents/utilities/Status/StatusTagDisplay";

import { JobStatus } from "entity/job/Job.api.types";

export const JobIcon: React.FunctionComponent<IJobIconProps> = ({
    currentJob,
    displayMode,
    showAccountingOnTimeClock,
    draftJobIds,
}) => {
    let jobIcon: string | null = null;
    let jobHoverText: string | undefined = undefined;
    let content: React.ReactNode;

    const showAccountingIcon = () => {
        const accountingTypes = [
            JobPickerDisplayModes.Jobsites,
            JobPickerDisplayModes.Budget,
            JobPickerDisplayModes.PurchaseOrder,
            JobPickerDisplayModes.OwnerPayments,
            JobPickerDisplayModes.Bills,
            JobPickerDisplayModes.PurchaseOrders,
        ];
        if (!currentJob.accountingEnabledImageSrc) {
            return false;
        }
        if (accountingTypes.includes(displayMode)) {
            return true;
        }
        if (displayMode === JobPickerDisplayModes.TimeClock) {
            return showAccountingOnTimeClock;
        }
        return false;
    };

    if (currentJob.jobId === GLOBAL_JOB) {
        jobIcon = "/images/TimeClock/TimeClockIcon.png";
        jobHoverText =
            "General allows you to clock in/out without assigning that time to a specific job.";
    } else if (currentJob.jobStatus === JobStatus.GeneralJob) {
        content = <BdsIconJobs />;
        jobHoverText = "Manage items that aren't assigned to a specific job.";
    } else if (currentJob.jobId === GLOBAL_DOCS) {
        jobIcon = "/images/Documents/folderGlobalx21.png";
        if (displayMode === JobPickerDisplayModes.Documents) {
            jobHoverText = "Global Documents Folder";
        }
        if (displayMode === JobPickerDisplayModes.Videos) {
            jobHoverText = "Global Videos Folder";
        }
        if (displayMode === JobPickerDisplayModes.Photos) {
            // Not currently a thing, but could become one in the future
            jobHoverText = "Global Photos Folder";
        }
    } else if (showAccountingIcon()) {
        jobIcon = currentJob.accountingEnabledImageSrc;
        jobHoverText = currentJob.accountingEnabledImageSrcHoverMsg || undefined;
        const label = getAccountingLabelText(currentJob.accountingType);
        content = (
            <StatusTagDisplay
                className="margin-right-xs"
                statusType={jobHoverText === "Pending Sync" ? "pending" : "success"}
                statusText={label}
            />
        );
    } else if (currentJob.hasTakeoff) {
        content = <BTIconTakeoffs data-testid={`job-takeoff-icon-${currentJob.jobId}`} />;
    } else if (draftJobIds.includes(currentJob.jobId)) {
        content = (
            <StatusTagDisplay className="margin-right-xs" statusType="info" statusText="Draft" />
        );
    }

    if (Boolean(jobIcon || content)) {
        const inner = (
            <div>
                {content ?? (
                    <img className="w-5 h-5 mr-2 float-right" src={jobIcon!} alt={jobHoverText} />
                )}
            </div>
        );
        if (jobHoverText) {
            return <BTPopover content={jobHoverText}>{inner}</BTPopover>;
        } else {
            return inner;
        }
    }
    return null;
};
